import { useEffect, useRef } from 'react';

/**
 * `show` が false→true のときだけ `onFreshOpen` を呼ぶ。
 * 送信直後の閉じ→エラー再オープンではフォームを消さない。
 */
export function useTppOnModalFreshOpen(show: boolean, onFreshOpen: () => void): void {
  const wasOpenRef = useRef(false);
  const cbRef = useRef(onFreshOpen);
  cbRef.current = onFreshOpen;

  useEffect(() => {
    if (show && !wasOpenRef.current) {
      cbRef.current();
    }
    wasOpenRef.current = show;
  }, [show]);
}
